export default __webpack_public_path__ + "static/media/property_371.682f474c.png";